import styled from "styled-components";
import { Flex } from "../../components/Flex";
import { Text } from "../../components/Text";
import { AikaTheme, themes } from "../../theme";
import { FaCheck, FaMoon, FaSun } from "react-icons/fa";
import { useSettings } from "../../Settings";

const Container = styled.div`
  width: 282px;
  border: 1px solid ${(props) => props.theme.colors.grey2};
  margin-right: 6px;
  margin-bottom: 6px;
  cursor: pointer;
`;

const Heading = styled.div`
  background-color: ${(props) => props.color};
  color: white;
  padding: 6px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`;

const ColorBlock = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.color};
`;

const ThemeDisplay = ({
  theme,
  active,
  onClick,
}: {
  theme: AikaTheme;
  active: boolean;
  onClick: () => void;
}) => {
  return (
    <Container onClick={onClick}>
      <Heading color={theme.colors.primary}>
        <Flex alignItems="center">
          {theme.dark ? (
            <FaMoon style={{ marginRight: 6 }} />
          ) : (
            <FaSun style={{ marginRight: 6 }} />
          )}
          {theme.name}
        </Flex>
        {active && <FaCheck />}
      </Heading>
      <Flex p={2} flexWrap="wrap">
        {theme.blockColors.map((x) => (
          <ColorBlock color={x} key={x} />
        ))}
      </Flex>
    </Container>
  );
};

export const ThemeSettings = () => {
  const [settings, setSettings] = useSettings();

  const setTheme = (themeId: string) => {
    setSettings({
      ...settings,
      theme: themeId,
    });
  };

  return (
    <div>
      <Text fontSize={4} fontWeight={600} mb={2}>
        Theme Settings
      </Text>
      <Text mb={3}>Customize your Aika...</Text>
      <Flex flexWrap="wrap">
        {themes.map((x) => (
          <ThemeDisplay
            key={x.id}
            theme={x}
            onClick={() => setTheme(x.id)}
            active={settings.theme === x.id}
          />
        ))}
      </Flex>
    </div>
  );
};
